import { useMemo } from 'react';

import Loading from '~/components/misc/loading';
import SuspenseWrapper from '~/components/misc/suspense-wrapper';

import useWizard from '~/components/authentication/wizard/hooks/use-wizard';
import WizardSidebar from '~/components/authentication/playnow/steps/common/sidebar';

const StepWizardInnerWrapper = ({ STEPMAP }) => {
	const { step, subStep } = useWizard();

	const ComponentToBeRendered =
		useMemo(
			() => STEPMAP[subStep?.key ?? step?.key],
			// eslint-disable-next-line react-hooks/exhaustive-deps
			[subStep?.key, step?.key]
		) ?? Loading;

	return (
		<WizardSidebar>
			<SuspenseWrapper withSuspense={step.withSuspense}>
				<ComponentToBeRendered />
			</SuspenseWrapper>
		</WizardSidebar>
	);
};

export default StepWizardInnerWrapper;
